export default {
  actions: {
    setStateId(ctx, id) {
      ctx.commit('setStateId', id)
    }
  },
  mutations: {
    setStateId(state, data) {
      state.stateId = data
    }
  },
  state: {
    stateId: null
  },
  getters: {
    getStateId(state) {
      return state.stateId
    }
  }
}
